import { Injectable } from "@angular/core";
import { ApiAction, ApiActionType } from "../../api-actions";
import { ApiPromiseState, ApiPromiseStateService } from "../../api-promise-state.service";
import { ApiSessionService } from "../../api-session.service";
import { ApiStateStoreService } from "../../api-state-store.service";
import { organizationId } from "../../apiParams/organization-id";
import { sessionId } from "../../apiParams/session-id";
import { OnsipApiResponse, extractData } from "../../apiResponse/response-body-new";
import { getApiActionName } from "../../onsip-api-action-new";
import { ApiResourceService } from "../api-resource.service";
import {
  CdrSummaryStatisticOrg,
  CdrSummaryStatisticParams,
  apiCdrOrgToCdrOrg as clean,
  ApiCdrSummaryStatisticOrg
} from "./cdr-summary-statistic";
import { arrayToRecord } from "../../util/arrayToRecord";

const debug = false;

@Injectable({ providedIn: "root" })
export class CdrSummaryStatisticOrgService extends ApiResourceService<CdrSummaryStatisticOrg> {
  constructor(
    session: ApiSessionService,
    store: ApiStateStoreService,
    promiseState: ApiPromiseStateService
  ) {
    super(session, store, promiseState, "CdrSummaryStatisticOrg", "calldate");

    debug && this.state.subscribe(state => console.warn("CdrSummaryStatisticOrg", state));
  }

  cdrSummaryStatisticOrg(
    extraParams?: CdrSummaryStatisticParams
  ): ApiPromiseState<CdrSummaryStatisticOrg> {
    this.dispatcher.next({
      parameters: {
        Action: ApiAction.CdrSummaryStatistic,
        SessionId: this.store.state.pipe(sessionId()),
        OrganizationId: this.store.state.pipe(organizationId()),
        DataGroup: "organization",
        ...extraParams
      }
    });
    return this.promiseState.toPromise("CdrSummaryStatisticOrg" as ApiActionType);
  }

  reducer(response: OnsipApiResponse): void {
    const action = getApiActionName(response);
    let result, validResult;
    switch (action) {
      case ApiAction.CdrSummaryStatistic:
        result = extractData<Array<ApiCdrSummaryStatisticOrg>>(
          response,
          action,
          "CdrSummary",
          "CdrSummaries"
        ).map(clean);
        // because there are 3 different data objects coming from CdrSummaryStatistics,
        // we will need to filter out the data objects that do not match the phone object
        validResult = result.every(data => !!data.calldate);
        if (validResult) {
          this.store.mergeStateUpdate(
            "CdrSummaryStatisticOrg",
            arrayToRecord(result, this.indexKeyName),
            "CdrSummaryStatisticOrg" as ApiActionType
          );
          break;
        }
        break;
    }
  }
}
